export default class SelectListItem {
    value: string | number = "";
    text: string = "";

    constructor(text: string, value: string | number) {
        this.value = value;
        this.text = text;
    }
}